import * as React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';

interface IProps {
    nextStepText: string;
    nextStepDisabled?: boolean;
    nextStepLoading?: boolean;
    onNext: () => void;
    onPrevious: () => void;
    previousStepDisabled?: boolean;
    previousText: string;
    actionButtonText?: string;
    actionButtonDisabled?: boolean;
    actionButtonLoading?: boolean;
    onActionButton?: () => void;
}

export const RefreshStepperButtons: React.FC<Readonly<IProps>> = (props) => (
  <div className="flex items-center gap-4 p-4 w-full bg-grey-0">
    {props.nextStepText
            && (
            <Button
              disabled={props.nextStepDisabled}
              loading={props.nextStepLoading}
              onClick={props.onNext}
              className="w-max-content"
            >
              {props.nextStepText}
            </Button>
            )}
    {
            props.actionButtonText && (
            <Button
              disabled={props.actionButtonDisabled}
              loading={props.actionButtonLoading}
              onClick={props.onActionButton}
              className="w-max-content"
            >
              {props.actionButtonText}
            </Button>
            )
        }
    {props.previousText
            && (
            <Button
              disabled={props.previousStepDisabled}
              onClick={props.onPrevious}
              variant="outline"
              className="w-max-content"
            >
              {props.previousText}
            </Button>
            )}
  </div>
);

RefreshStepperButtons.defaultProps = {
    nextStepDisabled: false,
    nextStepLoading: false,
    previousStepDisabled: false,
};
